<template>
    <div class="org-selector">
        <van-list
            class="list-wrap"
            v-model="loading"
            :finished="finished"
            finished-text=""
            @load="onLoad"
        >
            <van-search v-model="searchKey" placeholder="请输入账号或姓名" :clearable="false" v-show="option.type == 6"/>

            <h1 class="org-selector-title" v-show="option.type != 6">
                {{ option.name || '组织机构' }}
            </h1>

            <div class="group-list">
                <GroupItem
                    v-for="(item, index) in groupArr"
                    :key="index"
                    v-bind="item"
                    :show-checkbox="showCheckBox.includes(option.type)"
                    @click.native="queryData(item)"
                />
            </div>

            <div class="user-list">
                <UserItem
                    v-for="(item, index) in userArr"
                    :key="index"
                    :show-checkbox="showCheckBox.includes(6)"
                    v-bind="item"
                    @click.native="$emit('userClick', item)"
                />
            </div>
        </van-list>

        <div class="footer van-hairline--top">
            <van-icon name="arrow-left" @click="onBackClick" v-show="historyArr.length" size="24"/>
            <span class="btn-finish">{{ option.name || '组织机构' }}</span>
            <van-icon name="apps-o" @click="actionShow=true" size="24"/>
        </div>

        <button>全选</button>

        <van-action-sheet
            v-model="actionShow"
            :actions="menuActions"
            cancel-text="取消"
            close-on-click-action
            @cancel="actionShow=false"
            @select="onMenuSelect"
        />
    </div>
</template>

<script>
import {Search, ActionSheet, List, Toast} from 'vant'
import GroupItem from "@/components/OrgSelector/GroupItem"
import UserItem from "@/components/OrgSelector/UserItem"
import {parseItem, queryGroup, queryUser} from "@/api/org-selector";

export default {
    name: 'OrgSelector',
    components: {
        GroupItem, UserItem,
        [Search.name]: Search,
        [ActionSheet.name]: ActionSheet,
        [List.name]: List,
    },
    props: {
        showGroup: {
            type: Array,
            default() {
                return [
                    1, // 组织
                    4, // 职务
                    5, // 群组
                    6, // 人员
                    8, // 上下级
                    9, // 我带的课(老师用)
                    10 // 我选的课(学生用)
                ]
            }
        },
        showCheckBox: {
            type: Array,
            default() {
                return [
                    1, // 组织
                    2, // 部门
                    3, // 岗位
                    4, // 职位
                    5, // 群组
                    6, // 人员
                ]
            }
        },
        // 是否允许多选
        multiSelect: {
            type: Boolean,
            default: false
        },
        // 是否只加载组织机构，不加载人员
        groupOnly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            searchKey: '',
            groupArr: [],
            userArr: [],
            historyArr: [],
            actionShow: false,
            pageIndex: 0,
            loading: false,
            finished: true,
            option: {type: this.showGroup[0]},
        }
    },
    computed: {
        menuActions() {
            const LABEL = {
                1: '组织机构',
                4: '职务',
                5: '群组',
                6: '人员',
                8: '上下级',
                9: '我带的课',
                10: '我选的课',
            }

            return this.showGroup.map(type => ({name: LABEL[type], type}))
        },
    },
    methods: {
        queryData(option) {
            Promise.all([
                queryGroup(option),
                !this.groupOnly && queryUser(option)
            ]).then(([groupResp = [], userResp]) => {
                // 保存历史数据，方便返回上层
                if (this.groupArr.length)
                    this.historyArr.push([this.groupArr, this.userArr])

                this.groupArr = groupResp && groupResp.length ? groupResp.map(parseItem) : []

                if (userResp && userResp.data) {
                    this.userArr = userResp.data.map(parseItem)
                    this.finished = (this.pageIndex = userResp.currentPage) >= userResp.totalPage
                }
            }).catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))

        },

        onBackClick() {
            [this.groupArr, this.userArr] = this.historyArr.pop()
        },

        onMenuSelect(action) {
            this.historyArr = []
            this.groupArr = []
            this.userArr = []
            this.option = action
            this.queryData(action)
        },

        onLoad() {
            queryUser({pageIndex: this.pageIndex, ...this.option})
                .then(userResp => {
                    if (userResp) {
                        this.loading = false
                        this.finished = (this.pageIndex = userResp.currentPage) >= userResp.totalPage
                        this.userArr.push(...userResp.data.map(parseItem))
                    }
                })
                .catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))
        },
    },
    created() {
        this.queryData(this.option)
    }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.org-selector {
    height: 100vh;
    overflow: hidden;

    .list-wrap {
        height: calc(100vh - 50px);
        overflow-y: auto;
    }

    .footer {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        background-color: #ffffff;

        .btn-finish {
            flex: 1;
            text-align: center;
        }
    }

    .org-selector-title {
        color: #333;
        padding: 10px 15px;
        font-weight: 400;
        @extend .font14;
    }

    .van-search {
        background-color: transparent;
    }
}
</style>
